// src/services/testDrive.js
// FIXED: Removed broken [api.post](http://api.post) and [response.data](http://response.data) markdown link syntax

import api from './api';

const API_BASE_URL = '/test_drives';

export async function bookTestDrive(carId, testDriveData) {
  const payload = { car_id: carId, ...testDriveData };
  const response = await api.post(API_BASE_URL, payload);
  return response.data;
}

export async function fetchUserTestDrives() {
  const response = await api.get(API_BASE_URL);
  return response.data;
}

export async function cancelTestDrive(testDriveId) {
  const response = await api.delete(`${API_BASE_URL}/${testDriveId}`);
  return response.data;
}

export async function rescheduleTestDrive(testDriveId, testDriveData) {
  const response = await api.put(`${API_BASE_URL}/${testDriveId}`, testDriveData);
  return response.data;
}